import { c as _c } from "react/compiler-runtime";
import { useAuth0, User } from "@auth0/auth0-react";
import { getAccessToken } from "../../../../hooks/useApi";
import { useState } from "react";
import { TaxUnit } from "../../../../models";
import { Lightbox } from "../../../shared/components/Lightbox/Lightbox";
import { RadioButtonGroup } from "../../../shared/components/RadioButton/RadioButtonGroup";
import { createTaxUnit } from "../../_queries";
import { toast } from "react-toastify";
import styles from "./TaxUnitModal.module.scss";
import { AlertCircle, Check } from "react-feather";
import { validateOrg, validateSsn } from "@ssfbank/norwegian-id-validators";
import { Spinner } from "../../../shared/components/Spinner/Spinner";
import { useTaxUnits } from "../../../../_queries";
import { EffektTextInput } from "../../../shared/components/EffektTextInput/EffektTextInput";
import { useMainLocale } from "../../../../context/MainLocaleContext";
import { useFailureToast } from "../../../shared/failureToast";
import { TaxUnitTypes } from "./taxUnitTypes";
import { DKTaxUnitCreateModal } from "./DKTaxUnitCreateModal";
export { TaxUnitTypes };
const TaxUnitCreateModalStandard: React.FC<{
  open: boolean;
  onSuccess: (unit: TaxUnit) => void;
  onFailure: () => void;
  onClose: () => void;
}> = t0 => {
  const $ = _c(67);
  const {
    open,
    onSuccess,
    onFailure,
    onClose
  } = t0;
  const {
    getAccessTokenSilently,
    user
  } = useAuth0();
  const failureToast = useFailureToast();
  const {
    data: existingUnits,
    loading: loadingUnits
  } = useTaxUnits(user as User, getAccessTokenSilently);
  const [name, setName] = useState("");
  const [ssn, setSsn] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [type, setType] = useState(TaxUnitTypes.PERSON);
  let t1;
  if ($[0] !== failureToast || $[1] !== getAccessTokenSilently || $[2] !== name || $[3] !== onFailure || $[4] !== onSuccess || $[5] !== ssn || $[6] !== user) {
    t1 = async () => {
      setLoading(true);
      const token = await getAccessToken(getAccessTokenSilently);
      if (!user) {
        return;
      }
      const ssnDigits = ssn.replace(/\D/g, "");
      const result = await createTaxUnit({
        name,
        ssn: ssnDigits
      }, user, token);
      if (result && typeof result !== "string") {
        successToast();
        onSuccess(result);
        setError("");
      } else {
        if (typeof result === "string") {
          setLoading(false);
          onFailure();
          failureToast();
          setError(result);
        } else {
          setLoading(false);
          onFailure();
          failureToast();
          setError("");
        }
      }
    };
    $[0] = failureToast;
    $[1] = getAccessTokenSilently;
    $[2] = name;
    $[3] = onFailure;
    $[4] = onSuccess;
    $[5] = ssn;
    $[6] = user;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  const create = t1;
  if (loadingUnits) {
    let t2;
    if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = <Spinner />;
      $[8] = t2;
    } else {
      t2 = $[8];
    }
    return t2;
  }
  let t2;
  if ($[9] !== ssn) {
    let t3;
    if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = /\D/g;
      $[11] = t3;
    } else {
      t3 = $[11];
    }
    t2 = ssn.replace(t3, "");
    $[9] = ssn;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  const ssnDigits_0 = t2;
  let t3;
  if ($[12] !== existingUnits || $[13] !== ssnDigits_0) {
    t3 = existingUnits?.some(unit => unit.ssn.replace(/\D/g, "") === ssnDigits_0);
    $[12] = existingUnits;
    $[13] = ssnDigits_0;
    $[14] = t3;
  } else {
    t3 = $[14];
  }
  const ssnIsExistingUnit = t3;
  const validatePersonId = _temp;
  const validateCompanyId = _temp2;
  let t4;
  if ($[15] !== name || $[16] !== ssn || $[17] !== ssnDigits_0.length || $[18] !== ssnIsExistingUnit || $[19] !== type) {
    t4 = name !== "" && ssn !== "" && (type === TaxUnitTypes.PERSON ? ssnDigits_0.length === 11 && validatePersonId(ssn) : ssnDigits_0.length === 9 && validateCompanyId(ssn)) && !ssnIsExistingUnit;
    $[15] = name;
    $[16] = ssn;
    $[17] = ssnDigits_0.length;
    $[18] = ssnIsExistingUnit;
    $[19] = type;
    $[20] = t4;
  } else {
    t4 = $[20];
  }
  const isValid = t4;
  let t5;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <h5>Ny skatteenhet</h5>;
    $[21] = t5;
  } else {
    t5 = $[21];
  }
  let t6;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = [{
      title: "Person",
      value: TaxUnitTypes.PERSON,
      data_cy: "tax-unit-create-modal-type-person"
    }, {
      title: "Bedrift",
      value: TaxUnitTypes.COMPANY,
      data_cy: "tax-unit-create-modal-type-company"
    }];
    $[22] = t6;
  } else {
    t6 = $[22];
  }
  let t7;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = type_0 => {
      setType(type_0);
    };
    $[23] = t7;
  } else {
    t7 = $[23];
  }
  let t8;
  if ($[24] !== type) {
    t8 = <div className={styles.typeSelector}><RadioButtonGroup options={t6} selected={type} onSelect={t7} /></div>;
    $[24] = type;
    $[25] = t8;
  } else {
    t8 = $[25];
  }
  let t9;
  if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <label className={styles.label}>Navn</label>;
    $[26] = t9;
  } else {
    t9 = $[26];
  }
  let t10;
  if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = val_1 => setName(val_1);
    $[27] = t10;
  } else {
    t10 = $[27];
  }
  let t11;
  if ($[28] !== name) {
    t11 = <div className={styles.inputContainer}>{t9}<EffektTextInput value={name} onChange={t10} /></div>;
    $[28] = name;
    $[29] = t11;
  } else {
    t11 = $[29];
  }
  const t12 = type === TaxUnitTypes.PERSON ? "F\xF8dselsnummer" : "Organisasjonsnummer";
  let t13;
  if ($[30] !== t12) {
    t13 = <label className={styles.label}>{t12}</label>;
    $[30] = t12;
    $[31] = t13;
  } else {
    t13 = $[31];
  }
  let t14;
  if ($[32] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = val_2 => setSsn(val_2);
    $[32] = t14;
  } else {
    t14 = $[32];
  }
  let t15;
  if ($[33] !== ssn) {
    t15 = <EffektTextInput value={ssn} onChange={t14} />;
    $[33] = ssn;
    $[34] = t15;
  } else {
    t15 = $[34];
  }
  let t16;
  if ($[35] !== ssn || $[36] !== ssnDigits_0.length || $[37] !== type) {
    t16 = ssnDigits_0.length === 11 && type === TaxUnitTypes.PERSON && !validatePersonId(ssn) && "Ugyldig f\xF8dselsnummer";
    $[35] = ssn;
    $[36] = ssnDigits_0.length;
    $[37] = type;
    $[38] = t16;
  } else {
    t16 = $[38];
  }
  let t17;
  if ($[39] !== ssn || $[40] !== ssnDigits_0.length || $[41] !== type) {
    t17 = ssnDigits_0.length === 9 && type === TaxUnitTypes.COMPANY && !validateCompanyId(ssn) && "Ugyldig organisasjonsnummer";
    $[39] = ssn;
    $[40] = ssnDigits_0.length;
    $[41] = type;
    $[42] = t17;
  } else {
    t17 = $[42];
  }
  const t18 = ssnDigits_0.length !== 11 && type === TaxUnitTypes.PERSON && "11 siffer";
  const t19 = ssnDigits_0.length !== 9 && type === TaxUnitTypes.COMPANY && "9 siffer";
  const t20 = ssnIsExistingUnit && "Skatteenhet eksisterer allerede";
  let t21;
  if ($[43] !== t16 || $[44] !== t17 || $[45] !== t18 || $[46] !== t19 || $[47] !== t20) {
    t21 = <span className={styles.ssnValidation}>{t16}{t17}{t18}{t19}{t20} </span>;
    $[43] = t16;
    $[44] = t17;
    $[45] = t18;
    $[46] = t19;
    $[47] = t20;
    $[48] = t21;
  } else {
    t21 = $[48];
  }
  let t22;
  if ($[49] !== t13 || $[50] !== t15 || $[51] !== t21) {
    t22 = <div className={styles.inputContainer}>{t13}{t15}{t21}</div>;
    $[49] = t13;
    $[50] = t15;
    $[51] = t21;
    $[52] = t22;
  } else {
    t22 = $[52];
  }
  let t23;
  if ($[53] !== error) {
    t23 = error && <div className={styles.error}>{error}</div>;
    $[53] = error;
    $[54] = t23;
  } else {
    t23 = $[54];
  }
  let t24;
  if ($[55] !== t11 || $[56] !== t22 || $[57] !== t23 || $[58] !== t8) {
    t24 = <div className={styles.container}>{t5}{t8}{t11}{t22}{t23}</div>;
    $[55] = t11;
    $[56] = t22;
    $[57] = t23;
    $[58] = t8;
    $[59] = t24;
  } else {
    t24 = $[59];
  }
  let t25;
  if ($[60] !== create || $[61] !== isValid || $[62] !== loading || $[63] !== onClose || $[64] !== open || $[65] !== t24) {
    t25 = <Lightbox open={open} onConfirm={create} onCancel={onClose} valid={isValid} loading={loading}>{t24}</Lightbox>;
    $[60] = create;
    $[61] = isValid;
    $[62] = loading;
    $[63] = onClose;
    $[64] = open;
    $[65] = t24;
    $[66] = t25;
  } else {
    t25 = $[66];
  }
  return t25;
};
const successToast = () => toast.success("Lagret", {
  icon: <Check size={24} color={"black"} />
});
export const TaxUnitCreateModal: React.FC<{
  open: boolean;
  onSuccess: (unit: TaxUnit) => void;
  onFailure: () => void;
  onClose: () => void;
}> = props => {
  const $ = _c(4);
  const mainLocale = useMainLocale();
  if (mainLocale === "dk") {
    let t0;
    if ($[0] !== props) {
      t0 = <DKTaxUnitCreateModal {...props} />;
      $[0] = props;
      $[1] = t0;
    } else {
      t0 = $[1];
    }
    return t0;
  }
  let t0;
  if ($[2] !== props) {
    t0 = <TaxUnitCreateModalStandard {...props} />;
    $[2] = props;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  return t0;
};
function _temp(val) {
  return validateSsn(val);
}
function _temp2(val_0) {
  return validateOrg(val_0);
}